import React from 'react';
import {
  QueueListIcon,
  ClipboardDocumentListIcon,
  WrenchScrewdriverIcon,
  BeakerIcon,
  ArchiveBoxIcon,
  CheckCircleIcon,
} from '@heroicons/react/24/outline';

const VIEWS = [
  {
    key: 'anteojos-todos',
    label: 'Todos',
    icon: QueueListIcon,
    activeClass: 'bg-slate-100 text-slate-700',
  },
  {
    key: 'anteojos-tomados',
    label: 'Tomados',
    icon: ClipboardDocumentListIcon,
    activeClass: 'bg-blue-100 text-blue-700',
  },
  {
    key: 'anteojos-preparados',
    label: 'Preparados',
    icon: WrenchScrewdriverIcon,
    activeClass: 'bg-indigo-100 text-indigo-700',
  },
  {
    key: 'anteojos-laboratorio',
    label: 'Laboratorio',
    icon: BeakerIcon,
    activeClass: 'bg-yellow-100 text-yellow-700',
  },
  {
    key: 'anteojos-para-retirar',
    label: 'Para Retirar',
    icon: ArchiveBoxIcon,
    activeClass: 'bg-pink-100 text-pink-700',
  },
  {
    key: 'anteojos-entregados',
    label: 'Entregados',
    icon: CheckCircleIcon,
    activeClass: 'bg-purple-100 text-purple-700',
  },
];

const AnteojosSubNav = ({ currentView, onViewChange }) => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm mb-6">
      <nav className="flex gap-1 p-2">
        {VIEWS.map(({ key, label, icon: Icon, activeClass }) => {
          const isActive = currentView === key;
          return (
            <button
              key={key}
              onClick={() => onViewChange(key)}
              className={`flex-1 sm:flex-initial inline-flex flex-col sm:flex-row items-center justify-center sm:justify-start gap-1 sm:gap-2 px-1 sm:px-3 py-2 text-xs sm:text-sm font-medium rounded-lg transition-colors ${
                isActive
                  ? activeClass
                  : 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
              }`}
            >
              <Icon className="h-5 w-5 sm:h-4 sm:w-4 flex-shrink-0" />
              <span className="leading-tight text-center sm:text-left whitespace-nowrap">{label}</span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default AnteojosSubNav;
